import { render, staticRenderFns } from "./AppTermsIndex.vue?vue&type=template&id=6c91a322&scoped=true&"
import script from "./AppTermsIndex.vue?vue&type=script&lang=js&"
export * from "./AppTermsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91a322",
  null
  
)

export default component.exports